import React, { Component } from 'react'
import { ContextLoader } from '../../../utils/import.frames'

import background from './../../../UI/icons/Galerias/background.svg'

import close from './../../../UI/icons/Galerias/Close.svg'
import next from './../../../UI/icons/Galerias/next.svg'
import prev from './../../../UI/icons/Galerias/prev.svg'

import { vistaAptos as VData} from './../../../utils/vistas.data'
import { gallery as GData} from './../../../utils/galleryViews.data'
interface Props{
    isVista: boolean,
    handleThumbsVistas: any
}

interface State{
    currentSetSelected: any
    currentImage: string,
    showGallery: boolean,
    currentIndex: number,
    currentImageIndex: number
}


class ThumbsVistas extends React.Component<Props,State>{

    constructor(props: Props){
        super(props);
        this.state = {
            currentSetSelected: VData(),
            currentImage: "",
            showGallery: false,
            currentIndex: 0,
            currentImageIndex: 0
        }
    }

    componentDidMount(){
        this.setState({
            currentImage: ContextLoader["Piso " + VData()[this.state.currentIndex].Nombre]()[this.state.currentImageIndex]
        })
    }

    componentDidUpdate(prevProps: any){
        if(prevProps.isVista !== this.props.isVista && this.props.isVista){
            this.setState({
                showGallery: true,
                currentSetSelected: VData()
            })
        }
    }

    handleGetThumbs = () => {
        return(
            VData().map((data: any, index: number) => 
                <div className='individual-vista-container' key={index}>
                    <div className={this.state.currentIndex === index ? 'individual-vista-image-container thumb-selected':'individual-vista-image-container'}>
                        <img src={ContextLoader["Piso " + data.Nombre]()[0]} onClick = {() => {this.setState({currentIndex: index})}}></img>
                    </div>
                    <div className={this.state.currentIndex === index ? 'individual-vista-text-container':'individual-vista-text-container'}>
                        {
                            "Piso " + data.Nombre
                        }
                    </div>
                </div>
            )
        )
    }

    handleGetGallery = () => {
        //console.log(this.state.currentIndex);
        //console.log(VData());
        //console.log(ContextLoader["Piso " + VData()[this.state.currentIndex].Nombre]());
        
        
        //console.log(ContextLoader["Piso " + VData()[this.state.currentIndex].Nombre]()[this.state.currentImageIndex]);
        
        return(
            <>
            <img className="full-vistas-image" src={ContextLoader["Piso " + VData()[this.state.currentIndex].Nombre]()[this.state.currentImageIndex]}></img>
            <p className='name-gallery'>{"Piso " + VData()[this.state.currentIndex].Nombre +  " " + GData.Pisos[this.state.currentImageIndex]}</p>
        </>
        )
    }

    handleNextImage = () => {
        this.state.currentImageIndex + 1 > ContextLoader["Piso " + VData()[this.state.currentIndex].Nombre]().length - 1 ? this.setState({currentImageIndex: 0}):this.setState({currentImageIndex: this.state.currentImageIndex + 1})
    }

    handlePrevImage = () => {
        this.state.currentImageIndex - 1 < 0 ? this.setState({currentImageIndex: ContextLoader["Piso " + VData()[this.state.currentIndex].Nombre]().length - 1}):this.setState({currentImageIndex: this.state.currentImageIndex - 1})
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isVista ? 'full-container-vistas fade-in':'full-container-vistas fade-out'}>
                <img className="galerias-background" src={background}/>
                <div className='thumbs-container-vistas'>
                    {
                        this.handleGetThumbs()
                    }
                </div>
                <div className='opened-gallery-vistas'>
                    {
                        this.state.showGallery === true ? this.handleGetGallery(): null
                    }
                    {
                        <React.Fragment>
                             <div className="close-gallery-vista" 
                                onClick={() => {
                                        this.props.handleThumbsVistas("",false)
                                }}>
                                    <img src={close}></img>
                                </div>
                            <div className="next-gallery" onClick={() => {this.handleNextImage()}}>
                                <img src={next}></img>
                            </div>
                            <div className="previous-gallery" onClick={() => {this.handlePrevImage()}}>
                                <img src={prev}></img>
                            </div>
                        </React.Fragment>
                    }
                </div>
            </div>
        )
    }
}

export default ThumbsVistas